const getPlaceholderStandings = (): RoundRobinStanding[] =>
  new Array(8).fill(null).map((_, index) => ({
    opponent: {
      id: index + 1, // Negative IDs to indicate placeholder teams,
      name: 'TBD',
      image_url: '',
      dark_mode_image_url: '',
      slug: 'tbd'
    },
    rank: index + 1,
    stats: {
      game_losses: 0,
      game_wins: 0,
      match_draws: 0,
      match_losses: 0,
      match_wins: 0,
      game_draws: 0
    }
  }));

const getPlaceholderMatches = (): TournamentBracketMatch[] =>
  new Array(5).fill(null).map((_, index) => ({
    begin_at: '',
    forfeit: false,
    id: index + 1,
    match_type: '',
    game_advantage: null,
    opponents: [],
    games: [],
    status: 'not_started',
    number_of_games: 0,
    previous_matches: [],
    tag: '',
    winner_id: null
  }));

export { getPlaceholderStandings, getPlaceholderMatches };
